import { FetchResult, MaybeMasked } from '@apollo/client';
import {
  ArticleTranslationRevertDraftMutation,
  LanguageId,
  useArticleTranslationRevertDraftMutation,
} from 'lib-knowledge-management-common/graphql';

export function useRestoreVersion({
  articleId,
  languageId,
}: {
  articleId: string;
  languageId: LanguageId;
}): {
  restore: (
    versionNumber: number,
    publish?: boolean,
  ) => Promise<FetchResult<MaybeMasked<ArticleTranslationRevertDraftMutation>>>;
  loading: boolean;
} {
  const [restoreFn, { loading }] = useArticleTranslationRevertDraftMutation();

  const restore = (versionNumber: number, publish?: boolean) =>
    restoreFn({
      variables: {
        articleId,
        languageId,
        version: versionNumber,
        publish,
      },
    });

  return { restore, loading };
}
